import React, { useEffect } from "react";
import verifiedimg from "../../assets/images/varified.svg";
import notVerifiedImg from "../../assets/images/close-circlered.svg";
import logowhite from "../../assets/images/logowhite.svg";
import Images from "assets/images";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import useCurrentUser from "hooks/useCurrentUser";

const VerifyOtp = () => {
  const { user: currentUser } = useCurrentUser();
  const [searchParams] = useSearchParams();
  const verifyType = searchParams.get("type");
  const navigate = useNavigate();
  const LIVE_SITE_URL = process.env.REACT_APP_LIVE_SITE_URL;
  const { pilotProfileCompletedSteps, roleType, status } = currentUser || {};
  // const currentStep = parseInt(pilotProfileCompletedSteps);

  // const handleLogout = () => {
  //   if (roleType === 'PILOT' && currentStep === 3 && ['PENDING'].includes(status)) {
  //     localStorage.clear();
  //   }
  // }

  useEffect(() => {
    const keyDownHandler = event => {
      if (event.key === 'Enter') {
        navigate('/dashboard');
      }
    };

    document.addEventListener('keydown', keyDownHandler);

    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [currentUser]);

  return (
    <>
      <div className="container-fluid login-page p-0">
        <div className="row relative">
          <div className="col-lg-7 pr-0">
            <div className="right-login-side">
              <div className="nav-bar-container">
                <Link to="/" className="nav-bar">
                  <img alt="" src={Images.arrowleft} className="me-2 py-1" />
                  Home
                </Link>
              </div>

              <div className="outer-div-form">
                <div className="form-div">
                  <img width={220} height={220} alt='' src={status === 'PENDING' ? notVerifiedImg : verifiedimg} className="img-otp mx-auto d-block" />
                  <h4 className="text-center text-white form-hreading fw-bold">Verified!</h4>
                  <div className="tab-content-bg">
                    <div className="tab-content auth-tab-content px-lg-5 px-3">
                      <p className="text-center mx-auto mb-0">
                        {status === 'PENDING' ? 'Your account is not verified!' : 'You have successfully verified the account.'}
                      </p>
                      <div className="text-center">
                        <Link
                          to="/dashboard"
                          className="btn text-white text-capitalize btn-primary"
                        >
                          {verifyType === 'SIGN_IN' ? 'Go To Home' : 'Done'}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-flex mt-md-0 mt-2 flex-md-row flex-column bottom-ft justify-content-between auth-bottom-links">
                <div className="mb-lg-0 mb-3 d-flex justify-content-md-start justify-content-center">
                  <Link to={`${LIVE_SITE_URL}terms-conditions`}>Terms of Services</Link>
                  <Link to={`${LIVE_SITE_URL}privacy-policy`}>Privacy Policy</Link>
                </div>
                <div className="mb-lg-0 mb-3 d-flex justify-content-md-end justify-content-center">
                  <p>© 2023 SkyyTask. All rights reserved.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-5 pl-0 pr-0 pt-0">
            <div className="left-bg-form">
              <div className="logo-container w-100">
                <Link to="/" className="mx-auto mt-4 d-flex justify-content-center">
                  <img alt="" src={logowhite} className="logo" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VerifyOtp;
